import { Event, EventType } from "./Event";

import type { IAddInstantImpressionEvent } from "./types";

export class AddInstantImpressionEvent extends Event {
  constructor({
    itemId,
    page,
    section,
    position,
    tracking,
    customEventProperties,
  }: IAddInstantImpressionEvent) {
    super({
      event_type: EventType.instant_impression,
      event_properties: {
        item_id: itemId,
        page,
        section,
        position,
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
